import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import RegisterForm from '../components/auth/RegisterForm';
import BackLink from '../components/auth/BackLink';
import Brand from '../components/common/Brand';
import useAuth from '../hooks/useAuth';
import './RegisterPage.css';

const RegisterPage = () => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="auth-page">
      <BackLink />
      <div className="auth-page__container auth-page__container--wide">
        <div className="auth-page__brand">
          <h1><Link to="/" className="auth-page__home"><Brand /></Link></h1>
          <p>Create your account</p>
        </div>
        <div className="auth-page__card card">
          <div className="card-body">
            <h2 className="auth-page__title">Register</h2>
            <RegisterForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
